import CircularProgress from '@mui/material/CircularProgress'

import { Button } from './Button'

/**
 * Shows spinner on `isLoading` and natively disables button while loading.
 */
export function LoadingButton({
	children,
	isLoading = false,
	onClick,
	disabled,
	...props
}: Parameters<typeof Button>[0] & {
	isLoading?: boolean
}) {
	const finalDisabled = Boolean(disabled || isLoading)

	return (
		<Button disabled={finalDisabled} onClick={isLoading ? undefined : onClick} {...props}>
			{isLoading ? (
				<CircularProgress
					classes={{ colorPrimary: 'material-loader-black' }}
					size={20}
				/>
			) : (
				children
			)}
		</Button>
	)
}
